'use client'

import { parseAsString, useQueryState } from 'nuqs'
import { toast } from 'sonner'
import { useCart } from '@/lib/hooks'
import { cn } from '@/lib/utils'

import { ScrollArea, Skeleton } from '@/components/ui'
import { SearchCard, SearchCardSkeleton } from '@/components/molecules'

interface SearchResultProps extends React.ComponentPropsWithoutRef<'div'> {
  products: Product[]
}

export const SearchResult = ({ products }: SearchResultProps) => {
  const { selectProduct } = useCart()
  const [cartId] = useQueryState('cartId', parseAsString.withDefault(''))

  return (
    <ScrollArea
      className="w-full lg:h-[calc(100dvh-80px-24px-24px-52px-64px)] lg:max-h-[600px] lg:w-[calc(100%-8px)] lg:pl-4 lg:pr-2"
      scrollHideDelay={0}
    >
      <div className="flex flex-col gap-2 px-1 py-1 lg:px-2">
        {products?.map((product) => (
          <SearchCard
            key={product.id}
            product={product}
            onClick={() => {
              if (cartId) {
                selectProduct(product)
              } else {
                toast.error(
                  'Please start a "New Sale" first to add products to cart.',
                )
              }
            }}
          />
        ))}
      </div>
    </ScrollArea>
  )
}

interface SearchResultSkeletonProps
  extends React.ComponentPropsWithoutRef<'div'> {}

export const SearchResultSkeleton = ({
  className,
  ...restProps
}: SearchResultSkeletonProps) => {
  return (
    <div className={cn('flex w-full flex-col', className)} {...restProps}>
      <div className="flex items-center justify-between pb-5 pt-6">
        <Skeleton className="hidden h-4 w-[100px] rounded-full lg:flex" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-[100px] rounded-full" />
          <Skeleton className="h-4 w-[100px] rounded-full" />
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <SearchCardSkeleton />
        <SearchCardSkeleton />
        <SearchCardSkeleton />
        <SearchCardSkeleton />
      </div>
    </div>
  )
}
